export { ConfirmPageComponent, ConfirmReceivedPageComponent } from './pick-up-in-store'
export { default } from './store-locator'
export { default as StoreLocatorDetailPageComponent } from './store-locator-detail'
